module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "rectangle-7.76f1e4c1.svg";